import type { TipoAmbiente } from '@/@core/utils/enums/tributacion'

import { ref } from 'vue'
import { defineStore } from 'pinia'

export interface Empresa {
    id: number
    nombre: string
    id_tipo_contribuyente: number
    ContribuyenteEspecial: 1 | 0
    ObligadoContabilidad: 'SI' | 'NO'
    ambiente: TipoAmbiente
    gran_contribuyente: string
    mensaje_sri: string
    razonSocial: string
    ruc: string
    filesystem_prefix: string
}

export const useConfigStore = defineStore(
    'config',
    () => {
        const empresa = ref<Empresa | null>(null)
        return {
            empresa,
        }
    },
    {
        persist: {
            storage: localStorage,
        },
    }
)
